import { IAd, User } from 'utils/entities';
import { Poi } from 'utils/marketplaceRoutes';
import { poiEventPayload } from 'store/sagas/analytics/property';

export type SearchCardPoi = Poi | IAd;

export const SEARCH_EVENT_CATEGORY = 'search';
export const SEARCH_PROPERTY_CARD_EXPOSE_EVENT = 'search_property_card_expose';
export const SEARCH_PROPERTY_CARD_CLICK_EVENT = 'search_property_card_click';

interface SearchPropertyCardPayloadInput {
  poi: SearchCardPoi;
  currentUser: User | null;
  listIndex: number;
  page?: number;
}

export const buildSearchPropertyCardPayload = ({ poi, currentUser, listIndex, page }: SearchPropertyCardPayloadInput) => {
  if (!poi || poi.type === 'ad' || !Number.isInteger(listIndex)) return null;

  const { property } = poiEventPayload({ poi, estimatedPrice: null, isLeadingAgent: false, currentUser });
  if (!property) return null;

  return {
    event: {
      card_position: listIndex + 1,
      page_number: page || 1,
    },
    property,
  };
};
